import { Link } from 'react-router-dom';
import { site, stats } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20editorial%20collage%20of%20layered%20torn%20newsprint%20texture%20with%20a%20warm%20amber%20spotlight%20and%20deep%20crimson%20accents%2C%20moody%20cinematic%20grain%2C%20minimal%20composition%2C%20no%20text%2C%20muted%20charcoal%20background&width=1600&height=900&seq=guatian-hero-bg01&orientation=landscape"
          alt="瓜田档案局 - 网曝黑料合集与时间线整理站首页背景"
          title="网曝黑料合集 时间线整理"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/90"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-32 pb-16 md:pt-44 md:pb-24">
        <div className="mx-auto max-w-content">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-accent-500/15 px-4 py-1.5 text-xs font-medium text-accent-300">
            <i className="ri-radar-line text-sm"></i>
            已持续跟进 392 起热门事件
          </span>

          <h1 className="mt-6 max-w-4xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            瓜田档案局 · 网曝黑料合集帖
            <span className="text-accent-300">与时间线整理</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
            黑料合集帖、时间线整理、录音证据与聊天记录打包，一站在手吃瓜不愁。
            我们持续汇总全网热门事件，从爆料源头到发酵全程，帮你快速理清来龙去脉。
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/collections"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-stack-line"></i>
              翻阅爆料合集
            </Link>
            <Link
              to="/timeline"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 bg-background-50/10 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/20"
            >
              <i className="ri-timeline-view"></i>
              查看事件时间线
            </Link>
          </div>

          <dl className="mt-14 grid grid-cols-2 gap-x-6 gap-y-8 border-t border-background-100/20 pt-8 md:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="text-xs tracking-widest text-background-300">{item.label}</dt>
                <dd className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                  {item.value}
                  <span className="ml-1 text-sm font-normal text-accent-300">{item.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}